<template>
  <div>
    <v-btn color="purple" dark class="mt-2" rounded @click="showReport = true">
      <v-icon small class="mr-1 mb-1" size="17">mdi-tools</v-icon>Report
    </v-btn>

    <v-dialog v-model="showReport" persistent max-width="700">
      <v-card>
        <v-card-title class="headline"
          >Report en cours de validité</v-card-title
        >
        <v-card-text>
          <v-text-field
            label="Somme reportée"
            v-model="reportField"
            type="number"
            step="0.01"
            class="mt-3"
            filled
            rounded
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" text @click="showReport = false">Annuler</v-btn>
          <v-btn
            color="green darken-1"
            :loading="loading"
            @click="updateReport"
            dark
            >Valider</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { db } from "@/firebase";

export default {
  props: {
    report: Number,
  },

  data: () => ({
    showReport: false,
    reportField: 0,
    loading: false,
  }),

  mounted() {
    this.reportField = this.report / 100;
  },

  methods: {
    async updateReport() {
      this.loading = true;
      const id = this.$route.params.id;
      const report = Math.round(this.reportField * 100);
      await db.doc("clients/" + id).update({ report: report });
      this.loading = false;
      this.showReport = false;
    },
  },
};
</script>

